import { Helmet } from "react-helmet-async";

const SITE = "https://www.kerafoods.eu";

export default function Seo({ title, description, path = "/" }) {
  const fullTitle = title ? `${title} — KERA Foods` : "KERA Foods — South Indian Frozen & Dry Food Wholesale Across Europe";
  const desc = description || "KERA Foods brings authentic South Indian frozen and dry food — porotta, idiyappam, snacks and curries — from Kerala to wholesale partners across Europe.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={`${SITE}${path}`} />
    </Helmet>
  );
}
